import { createContext, useContext } from 'react';
import { OrganizationMembershipResponse } from '@/shared/api';

type RouterContextType = {
  activeOrganization?: Partial<OrganizationMembershipResponse>;
  setActiveOrganization: (org?: OrganizationMembershipResponse) => void;
  dashboardGoBackLink: string;
  setDashboardGoBackLink: (link: string) => void;
};

export const RouterContext = createContext({} as RouterContextType);

export const useRouterContext = () => {
  const context = useContext(RouterContext);
  if (context === undefined) {
    throw new Error('useAppGlobalContext must be used within PrivateRoutes');
  }
  return context;
};
